export const money = (n) =>
  n == null || isNaN(n)
    ? "—"
    : new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n);

export const num = (n, d = 0) =>
  n == null || isNaN(n)
    ? "—"
    : new Intl.NumberFormat("en-US", { maximumFractionDigits: d, minimumFractionDigits: d }).format(n);

export const pct = (n, d = 1) => (n == null || isNaN(n) ? "—" : `${Number(n).toFixed(d)}%`);

// Clean to a valid 10-digit NANP phone; returns "" when no valid US number can be extracted.
// Mirrors the backend rl_bol._phone() so client and server agree on what R+L will accept.
export const normalizePhone = (v) => {
  let d = String(v || "").replace(/\D/g, "");
  if (d.length === 11 && d.startsWith("1")) d = d.slice(1);
  if (d.length > 10) d = d.slice(0, 10);
  if (d.length !== 10 || "01".includes(d[0]) || "01".includes(d[3])) return "";
  return d;
};

export const dateShort = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return iso;
  }
};

export const marginColor = (health) =>
  health === "green"
    ? "text-[hsl(var(--success))]"
    : health === "yellow"
    ? "text-[hsl(var(--warning))]"
    : "text-[hsl(var(--destructive))]";

export const marginBg = (health) =>
  health === "green"
    ? "bg-[hsl(var(--success))]/15 border-[hsl(var(--success))]/40"
    : health === "yellow"
    ? "bg-[hsl(var(--warning))]/15 border-[hsl(var(--warning))]/40"
    : "bg-[hsl(var(--destructive))]/15 border-[hsl(var(--destructive))]/40";
